module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('ul', {
    staticClass: "list list-box p0002"
  }, [_c('dmenu', {
    attrs: {
      "alias": "center",
      "name": "Center"
    },
    on: {
      "on-switch": _vm.play
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "alias": "bottom",
      "name": "Bootom"
    },
    on: {
      "on-switch": _vm.play
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "alias": "left",
      "name": "Left"
    },
    on: {
      "on-switch": _vm.play
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "alias": "top",
      "name": "Top"
    },
    on: {
      "on-switch": _vm.play
    }
  }), _vm._v(" "), _c('dmenu', {
    attrs: {
      "alias": "top-header",
      "name": "Top with header"
    },
    on: {
      "on-switch": _vm.play
    }
  })], 1), _vm._v(" "), _c('drawer', {
    attrs: {
      "show": _vm.show,
      "position": _vm.pos
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "padding": "40px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-block",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("关 闭")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a45efdf2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/drawer/demo.vue
// module id = 277
// module chunks = 9